module.exports = __webpack_public_path__ + "img/【诊改行动】数实融合，共谋新篇！上电智联助力阳光能源开启主数据系统项目.6ca3b1ab.jpg";